///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor = abcsetup.new_vendor || {};
abcsetup.new_vendor.create = abcsetup.new_vendor.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor.create = {
    /**
     *
     */
    init: function () {
        abcsetup.setTitle('SAP Supplier');
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        // Bind any fields events
        abcsetup.new_vendor.common.bindFields();
    },

    /**
     * bootstrap-autocomplete - this is the callback when an item is selected
     */
    autoCompleteSelected: function() {
        abcsetup.new_vendor.common.autoCompleteSelected();
    },

    /**
     * bootstrap-autocomplete - this is the callback when a free form value is entered
     */
    autoCompleteFreevalue: function() {
        abcsetup.new_vendor.common.autoCompleteFreevalue();
    },
}
